<template>
  <div :class="mobile ? 'profile-mobile' : 'profile'">
    <div class="flex-between">
      <p class="no-wrap">
        <span>{{ $t('clinic.clinic') }}</span>
        {{ session.currentClinic.name }}
      </p>
      <button class="btn-icon" type="button" name="button" data-test="btnChangeClinic" @click="openChangeOffcanvas">
        <IconChange/>
      </button>
    </div>

    <div class="flex-between">
      <button class="no-wrap btn-outline-hover" type="button" name="button" data-test="btnProfile" @click="profileMenu">
        <span v-if="mobile">{{ $t('user.user') }}</span>
        <IconPatientsSearch v-else/>
        {{ fullName }}
      </button>

      <button class="btn-icon btn-outline-hover" type="button" name="button" data-test="btnNews" @click="newsMenu()">
        <IconNews/>
      </button>

      <button class="btn-icon btn-outline-hover" type="button" name="button" data-test="btnDocs" v-if="isDocsAvailable" @click="docsMenu()">
        <i class="fa fa-code" aria-hidden="true"></i>
      </button>

      <BaseFeature feature="backoffice">
        <button class="btn-icon btn-outline-hover" type="button" name="button" data-test="btnBackoffice" v-if="!isSpecialist" @click="backofficeMenu()">
          <IconEye/>
        </button>
      </BaseFeature>

      <button class="btn btn-icon btn-notif btn-outline-hover" :class="{'btn-spinner': isLoading}" type="button" name="button" id="notifications"
              data-test="btnNotification" @click="resetNotifications">
        <IconAlert/>
        <span id="notification-count" class="notification-count">{{ notificationCount }}</span>
      </button>

      <div class="flex-center" v-if="mobile">
        <button class="btn-icon btn-notif" :class="{'btn-spinner': isLoading}" type="button" name="button" id="notifications"
                data-test="btnNotification" @click="resetNotifications">
          <IconAlert/>
          <span id="notification-count" class="notification-count">{{ notificationCount }}</span>
        </button>

        <button class="btn-icon" type="button" name="button" data-test="btnLogout" @click="logout()">
          <IconLogout/>
        </button>
      </div>
    </div>

    <teleport to="body">
      <ClinicChangeOffcanvas v-if="isSmallScreen" :offcanvas_id="'ClinicChangeOffcanvas'" ref="clinicChangeOffcanvas"/>
      <NotificationsOffcanvas :offcanvas_id="'NotificationsOffcanvas'" :notification="notification" ref="notificationsOffcanvas"/>
      <UserShowOffcanvas ref="userShowOffcanvas"/>
    </teleport>
  </div>
</template>

<style lang="scss" scoped>

.profile {
  display:                            flex;
  flex-direction:                     row;
  height:                             62px;

  > div {
    gap:                              10px;
    // padding:                          10px 10px 10px 20px;
    width:                            auto;

    svg * {
      stroke:                         var(--Shades-00);
    }

    &:first-child {
      display:                        none;
      border-right:                   1px solid var(--Shades-20-Border);
      border-left:                    1px solid var(--Shades-20-Border);

      p.no-wrap {
        white-space:                  nowrap;
        width:                        100%;
        max-width:                    150px;
      }

      .btn-icon {
        padding:                      4px !important;
      }
    }
    &:last-child {
      // border-right:                   1px solid var(--Shades-20-Border);

      .no-wrap {
        @include                      border_radius(30px);
        display:                      flex;
        flex-direction:               row;
        justify-self:                 center;
        align-items:                  center;
        width:                        auto !important;
        height:                       36px;
        padding:                      10px 15px 10px 10px;
        gap:                          10px;
        background:                   var(--Shades-W);
        border:                       1.5px solid var(--Shades-30-Border);
        cursor:                       pointer;
      }
    }

    .no-wrap {
      color:                          var(--Shades-80);
      font-size:                      var(--font-size-14);
      font-weight:                    500;
      letter-spacing:                 0.7px;
      font-family:                    inherit;
      text-align:                     left;
      background:                     none;
      border:                         0;
      padding:                        0;
      margin:                         0;
      span {
        color:                        var(--Shades-50);
        font-size:                    var(--font-size-10);
        letter-spacing:               1.5px;
        text-transform:               uppercase;
        display:                      block;
      }
    }

    .btn-icon {
      display:                        flex;
      align-items:                    center;
      justify-content:                center;
      width:                          30px;
      height:                         30px;
      padding:                        unset;
      background:                     var(--Shades-W);
      border:                         1px solid var(--Shades-30-Border);

      svg {
        width:                        20px;
        height:                       20px;
      }

      &.btn-notif {
        position:                     relative;
        padding:                      unset;
        margin-right:                 10px;

        .notification-count {
          @include                    border_radius(50%);
          color:                      white;
          font-size:                  0.8em;
          line-height:                normal;
          position:                   absolute;
          top:                        -2px;
          right:                      -5px;
          display:                    flex;
          justify-content:            center;
          align-items:                center;
          width:                      15px;
          height:                     15px;
          background-color:           #00b99f;
        }
      }

      &.btn-outline-hover {
        width:                        36px !important;
        height:                       36px !important;
        margin:                       0;
        border:                       1.5px solid var(--Shades-30-Border);

        svg {
          width:                      16px;
          height:                     16px;
        }
      }
    }
  }
}

.profile-mobile {
  display:                            flex;
  flex-direction:                     column-reverse;
  height:                             auto;
  margin-bottom:                      20px;

  > div {
    @include                          border_radius(15px 15px 0 0);
    display:                          flex;
    gap:                              10px;
    padding:                          10px 10px 10px 20px;
    width:                            100%;
    background:                       var(--Shades-BG);
    border:                           1px solid var(--Shades-30-Border);

    svg * {
      stroke:                         var(--Shades-00);
    }

    &:first-child {
      @include                        border_radius(0 0 15px 15px);
      border-top:                     0;

      p.no-wrap {
        white-space:                  nowrap;
        width:                        100%;
        max-width:                    150px;
      }

      .btn-icon {
        padding:                      4px;
      }
    }

    &:last-child {
      .no-wrap {
        cursor:                       pointer;
      }
    }

    .no-wrap {
      color:                          var(--Shades-80);
      font-size:                      var(--font-size-14);
      font-weight:                    500;
      letter-spacing:                 0.7px;
      font-family:                    inherit;
      text-align:                     left;
      background:                     none;
      border:                         0;
      padding:                        0;
      margin:                         0;

      span {
        color:                        var(--Shades-50);
        font-size:                    var(--font-size-10);
        letter-spacing:               1.5px;
        text-transform:               uppercase;
        display:                      block;
      }
    }

    .btn-icon {
      display:                        flex;
      align-items:                    center;
      justify-content:                center;
      width:                          30px;
      height:                         30px;
      padding:                        unset;
      background:                     var(--Shades-W);
      border:                         1px solid var(--Shades-30-Border);

      svg {
        width:                        20px;
        height:                       20px;
      }

      &.btn-notif {
        position:                     relative;
        padding:                      unset;
        margin-right:                 10px;

        .notification-count {
          @include                    border_radius(50%);
          color:                      white;
          font-size:                  0.8em;
          line-height:                normal;
          position:                   absolute;
          top:                        -2px;
          right:                      -5px;
          width:                      15px;
          height:                     15px;
          background-color:           #00b99f;
        }
      }

      &.btn-outline-hover {
        display:                      none;
      }
    }
  }
}
</style>

<script>
import { useUserStore } from '@/store/user'
import ClinicChangeOffcanvas from '../clinic/ClinicChangeOffcanvas.vue'
import NotificationsOffcanvas from './NotificationsOffcanvas.vue'
import UserShowOffcanvas from '../user/user-show/UserShowOffcanvas.vue'
import profile_img from "@/assets/images/phelcom/profile_img.png";

export default {
  name: 'MenuProfile',
  props: {
    mobile: { type: Boolean, default: false },
  },
  components: {
    ClinicChangeOffcanvas,
    NotificationsOffcanvas,
    UserShowOffcanvas
  },
  data: () => ({
    profileAvatar: false,
    currentClinicID: null,
    key: null,
    session: {
      collaborator: {},
      currentClinic: {}
    },
    isLoading: false,
    fullName: null,
    isWebSocketConnected: false,
    notificationData: {
      count: 0,
      events: []
    },
    notificationCount: 0,
    notification: [],
    showOffcanvas: false,
    showNotificationsOffcanvas: false,
    isSmallScreen: false,
  }),
  computed: {
    avatar() {
      return this.session.userPhoto ? this.session.userPhoto : profile_img;
    },
    isDocsAvailable() {
      const hostname = window.location.hostname
      const isDevEnv = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === 'dev2.eyercloud.com'
      if (!isDevEnv) return false
      const email = this.session?.collaborator?.email || ''
      return /@phelcom\.com(\.br)?$/.test(email)
    },
  },
  mounted() {
    const userStore = useUserStore()
    this.session = userStore.sessionInfo
    this.fullName = `${this.session.collaborator.firstName} ${this.session.collaborator.lastName}`
    this.currentClinicID = this.session.currentClinic.id
    const uuid = this.session.currentClinic.uuid
    this.key = `clinic_${this.currentClinicID}_${uuid}`

    this.emitter.on("profilePhotoChanged", imagePath => {
      this.session.userPhoto = imagePath
    })

    this.webSocketInitialization()

    this.$nextTick(() => {
      this.reloadNotifications()
    })

    // called from notificationService (logic is there)
    this.emitter.on("newNotification", event => {
      this.notification.push(event)
      this.notificationCount += 1 // view logic
    })

    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  methods: {
    handleResize() {
      this.isSmallScreen = window.innerWidth < 992;
    },
    profileMenu() {
      if (this.isSmallScreen)
        this.$emit('do-toggle')

      this.$refs.userShowOffcanvas.show()
    },
    async clinicDetails() {
      NProgress.start()
      try {
        let params = {
          id: this.session.currentClinic.id
        }

        let response = await this.$clinicService.getClinic(params);
        const freshClinic = response.clinic
        this.session.activeLink = 'clinic'

        let data = this.$utils.dataQuery({
          clinic: JSON.stringify(freshClinic)
        })

        this.$router.push({name: 'clinic-show', params: {clinicID: freshClinic.id}, query: {tab: 'data', data}})
      } catch (err) {
        console.log("unexpectedError", err)
      }
      NProgress.done(true)
    },

    webSocketInitialization() {
      // TODO REFACTOR duplicated code -> use event bus
      const io = this.$io
      this.isWebSocketConnected = io.socket.isConnected()

      if (this.isWebSocketConnected) {
        io.socket.disconnect()
        io.socket.reconnect()
      }

      io.socket.on('connect', () => {
        this.isWebSocketConnected = true
      })

      io.socket.on('disconnect', () => {
        this.isWebSocketConnected = false
      })
    },

    reloadNotifications() {
      if (!this.currentClinicID)
        return

      const clinicData = this.$notificationService.reloadNotifications(this.currentClinicID)
      for (let e of clinicData.events) {
        this.addNotification(e)
      }

      this.notificationCount = clinicData.count
    },

    // bell icon clicked
    async resetNotifications() {
      // this.showNotificationsOffcanvas = true

      this.notificationCount = 0
      this.$notificationService.resetCount(this.currentClinicID)
      this.$notificationService.enable() // force notification activation

      await this.$refs.notificationsOffcanvas.show({
        // notification: this.notification
      })
    },

    addNotification(data) {
      try {
        this.notification.unshift(data)
      } catch (e) {
        console.log('error(addNotification)', e);
      }
    },

    async notificationClicked(examid) {
      try {
        let params = {
          id: examid,
        }

        let response = await this.$examService.get(params);

        let data = this.$utils.dataQuery({
          exam: JSON.stringify(response.exam)
        })

        this.$router.push({name: 'exam-show', params: {examID: examid}, query: {tab: 'images', data}})
      } catch(err) {
        this.alert = {
          message: `${this.$i18n.t('request_error')} <strong>${err}</strong>`,
          class: 'alert-danger'
        }
      }
    },

    async openChangeOffcanvas() {
      await this.$refs.clinicChangeOffcanvas.show({})
    },

    async logout() {
      await this.$authService.logout(this)
      window.open('/', '_self');
    },

    docsMenu() {
      this.goToLink(this, 'docs', 'docs')
    },

    newsMenu() {
      this.emitter.emit('open-news-modal')
    },

    backofficeMenu() {
     const IS_PRODUCTION = process.env.NODE_ENV == 'production'
     let BASE_URL = 'http://bo2.eyercloud.com/'
     if (!IS_PRODUCTION){
        BASE_URL = 'http://devbo2.eyercloud.com/'
      }
      window.location = `${BASE_URL}`
    },

    goToLink(self, active, link) {
      self.active = active

      self.$router.push({name: 'proxy-router', params: {
        target: link,
        data: JSON.stringify({})
      }})
    },
  }
}

</script>
